import { WriterTypes } from '../../enums/file-writer/writer-types';
import { IFileWriter } from '../../interfaces/file-io/ifile-writer';
import { FileWriterConfigTypes } from '../../types/file-writer-config-types';
import { CsvWriterProps } from '../file-writer/csv-writer-props';
import { S3ConnectorBase } from './s3-connector-base';

/**
 * Configuration for an S3Writer task. Extends S3ConnectorBase with file
 * format settings. writerConfig shape depends on writerType (CSV/XML/JSON).
 * The final S3 object key is formed as: `{dir}/{writerConfig.fileName}`.
 */
export class S3WriterConfig extends S3ConnectorBase implements IFileWriter {
	/**
	 * File format to write. CSV=0, XML=1, JSON=2.
	 * @default WriterTypes.CSV
	 */
	writerType = WriterTypes.CSV;

	/**
	 * Format-specific writer configuration. Use CsvWriterProps for CSV,
	 * XmlWriterProps for XML, JsonWriterProps for JSON. All types inherit
	 * FileWriterBase (fileName, writeMode, lineEnd, exportBehavior, uniqueness).
	 * fileName inside this config is the output file name; combined with dir for the final S3 key.
	 */
	writerConfig: FileWriterConfigTypes = new CsvWriterProps();

	/**
	 * Optional S3 key prefix (folder path) prepended to writerConfig.fileName.
	 * Final S3 object key = `{dir}/{fileName}`.
	 */
	dir?: string;

	constructor(init?: Partial<S3WriterConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
